<svelte:options accessors/>
<script lang="ts">
    import NauiCheckbox from "../naui/atoms/NauiCheckbox.svelte";
    import NauiSelect from "../naui/atoms/NauiSelect.svelte";
    import NauiFilters from "../naui/components/NauiFilters.svelte";
    import NauiTag from "../naui/atoms/NauiTag.svelte";
    import NauiButton from "../naui/atoms/NauiButton.svelte"
    import NauiSlideOver from "../naui/layout/NauiSlideOver.svelte";
    import type {IAsignacion} from "../interfaces/asignacion.interface";
    import type {ISelectOption} from "../interfaces/select-option.interface";
    import {createEventDispatcher} from "svelte";
    import LoadingBar from "./components/modals/LoadingBar.svelte";
    import NauiSearcher from "../naui/components/NauiSearcher.svelte";

    export let editable: boolean = true;
    export let assignable: boolean = true;
    export let list: Array<IAsignacion> = [];
    export let filters = [];
    export let businessUnits: Array<ISelectOption> = [];
    export let loading: boolean = false;

    const dispatch = createEventDispatcher();

    let selectedAll: boolean = false;
    let countSelected: number = 0;
    let selectedBU: number
    let open: boolean = false;
    let currentFilters: any;
    let term = '';

    export function updateSelected() {
        countSelected = list.filter((i: any) => i.selected).length
    }

    function selectAll() {
        list.forEach((i: any) => {
            i.selected = selectedAll
        });
        list = [...list];
        updateSelected();
    }

    function assignBUToItems() {
        open = false;
        dispatch('setBU', {
            'items': list.filter((l: any) => l.selected).map((l: any) => l.id),
            'bu': selectedBU
        });
    }

    function handleSearch(evt) {
        term = (evt.detail || {term: ''}).term
        dispatch('filtered', {
            term,
            ...currentFilters
        })
    }

    function filter(evt) {
        countSelected = 0;
        currentFilters = evt.detail;
        dispatch('filtered', {
            term,
            ...currentFilters
        })
    }
</script>
<div class="pb-15">
    <div class="box-b">
        <div class="box-l sx-ii">
            <NauiSearcher on:search={handleSearch}/>
            <NauiFilters {filters}
                         on:filtered={filter}/>
            {#if !loading}
                <div class="radius py-ii px-1 back-gray"><strong class="mr-i">{list?.length || 0}</strong>Items</div>
            {/if}
        </div>
        <div>
            {#if countSelected > 0}
                <NauiButton caption={`ASIGNAR UNIDAD DE NEGOCIO (${countSelected})`}
                            mode="outline"
                            color="accent"
                            on:click={()=>open = true}/>
            {/if}
        </div>
    </div>
</div>
{#if loading}
    <div class="text-c">
        <LoadingBar/>
    </div>
{:else}
    <table class="naui-table w-100">
        <thead>
        <tr>
            {#if assignable}
                <th>
                    <div>
                        <NauiCheckbox bind:value={selectedAll}
                                      on:change={selectAll}/>
                    </div>
                </th>
            {/if}
            <th>
                <div>Item</div>
            </th>
            <th style="width: 10%">
                <div>Grupo</div>
            </th>
            <th style="width: 10%">
                <div>Código institucional</div>
            </th>
            <th>
                <div>Nombre solicitado por el cliente</div>
            </th>
            <th style="width: 10%">
                <div>Cantidad</div>
            </th>
            <th>
                <div class="box">UN</div>
            </th>
        </tr>
        </thead>
        <tbody>
        {#each list as item, index (item.slug)}
            <tr>
                {#if assignable}
                    <td>
                        <div>
                            <NauiCheckbox bind:value={item.selected}
                                          on:change={updateSelected}/>
                        </div>
                    </td>
                {/if}
                <td>
                    <div>
                        {item?.number ? item?.number: ''}
                    </div>
                </td>
                <td>
                    <div>
                        <input type="text"
                               readonly={!editable}
                               bind:value={item.group}
                               class="naui-input w-100" style="width: 150px">
                    </div>
                </td>
                <td>
                    <div>
                        <input type="text"
                               readonly={!editable}
                               bind:value={item.code}
                               class="naui-input w-100" style="width: 150px">
                    </div>
                </td>
                <td>
                    <div>
                        <input type="text"
                               readonly={!editable}
                               bind:value={item.name}
                               class="naui-input w-100">
                    </div>
                </td>
                <td>
                    <div>
                        <input type="number"
                               readonly={!editable}
                               bind:value={item.quantity}
                               class="naui-input w-100" style="width: 100px">
                    </div>
                </td>
                <td>
                    <div class="box">
                        {#if item?.bu}
                            <NauiTag label={item.bu?.name}
                                     backColor={item.bu?.color}
                                     borderColor={item?.bu?.color}
                                     textColor={item?.bu?.text_color}/>
                        {/if}
                    </div>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
{/if}
<NauiSlideOver bind:open={open}
               title="Asignar a unidad de negocio">
    <NauiSelect label="Unidad de Negocio"
                options={businessUnits}
                bind:value={selectedBU}/>
    <div slot="actions" class="box">
        <NauiButton caption="ASIGNAR"
                    color="accent"
                    mode="outline"
                    className="min-w-300px"
                    on:click={assignBUToItems}/>
    </div>
</NauiSlideOver>


